import styled from '@emotion/styled';
import { Button } from '@mui/material';
import React from 'react';
import { VisibilityOffOutlined as ImageHiddenIcon } from '@mui/icons-material';
import addHighContrastStyles from '@/lib/styling/addHighContrastStyles';
import { FormattedMessage } from 'react-intl';

const StyledOverlay = styled('div')(
  {
    position: 'absolute',
    top: 0,
    left: 0,
    paddingLeft: 12,
    paddingRight: 12,
    width: '100%',
    height: '100%',
    color: 'white',
    backgroundColor: 'rgba(0, 0, 0, 0.4)',
    backdropFilter: 'blur(40px)',
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    '.MuiSvgIcon-root': {
      marginBottom: 18,
      width: 48,
      height: 48,
    },
    h3: {
      marginBottom: 24,
      textAlign: 'center',
    },
  },
  addHighContrastStyles(({ theme }) => ({
    color: theme.palette.text.primary,
    backgroundColor: theme.palette.background.default,
  })),
);

type PreviewDialogInappropriateContentOverlayProps = {
  visible: boolean;
  onClose: (event: React.MouseEvent<HTMLButtonElement>) => void;
};

const PreviewDialogInappropriateContentOverlay = ({
  visible,
  onClose,
}: PreviewDialogInappropriateContentOverlayProps) => {
  if (!visible) {
    return null;
  }

  return (
    <StyledOverlay>
      <ImageHiddenIcon />
      <h3>
        <FormattedMessage id="portfolio.challenge.files.uploaded_image.preview_dialog.inappropriate_content_overlay.title" />
      </h3>
      <Button variant="contained" onClick={onClose} disableElevation>
        <FormattedMessage id="portfolio.challenge.files.uploaded_image.preview_dialog.inappropriate_content_overlay.button" />
      </Button>
    </StyledOverlay>
  );
};

export default PreviewDialogInappropriateContentOverlay;
